"use strict";
var FromEventPatternObservable_1 = require('./FromEventPatternObservable');
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/rxjs/observable/fromEventPattern.js
 ** module id = 402
 ** module chunks = 0 1 2
 **/